The identifier for the `HiringOrganization` that submitted the candidate profile.
